import $ from 'jquery';
import _ from 'lodash-es';
import { keyCodes } from '../../../../../@infinite/scripts/core/INF-keyCodes';
import { standardizeHeights } from '../../../../../@infinite/scripts/core/INF-gridAlignment';
import formatTriggers from './formatTriggers'; 
import prepareModal from './prepareModal';
import positionModal from './positionModal';
import handleShoppablePause from './handleShoppablePause';
import initCarousels from '../SimpleCarousel/initCarousels';
// import getProduct from './getProduct';


export default () => {
  handleShoppablePause();
  formatTriggers();

  const grid_item_selector = '[data-product-tile]';
  const child_selectors = [
    '[data-product-tile-image]',
    '[data-product-tile-title]',
    '[data-product-tile-price]',
  ];

  $(document).on('click', '[data-shoppable]', (e) => {
    if (e.keyCode) {
      if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
    }

    e.preventDefault();
    const $shoppableTrigger = $(e.currentTarget);
    const items_data = $shoppableTrigger.data('shoppable');
    let img_src = $shoppableTrigger.data('shoppableImg');

    if (!img_src) {
      img_src = $shoppableTrigger.attr('src');
    }

    if (!img_src || !items_data) { return; }

    if (!window.shoppablePaused) {
      console.log('prepareModal', $shoppableTrigger, items_data, img_src);
      prepareModal($shoppableTrigger, items_data, img_src);
    }
  });

  $(document).on('click', '[data-shoppable-trigger]', (e) => {
    if (e.keyCode) {
      if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
    }

    e.preventDefault();
    const $shoppableTrigger = $(e.currentTarget);

    if ($shoppableTrigger.siblings('[data-shoppable]')) {
      $shoppableTrigger.siblings('[data-shoppable]').trigger('click');
    }
  });

  // $(document).on('click', '[data-shoppable-image-modal] a:not([data-shoppable-ignore])', (e) => {
  //   if (e.keyCode) {
  //     if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
  //   }

  //   const $link = $(e.currentTarget);

  //   if (!$link.attr('href') || ($link.attr('href') && $link.attr('href').indexOf('/products/') === -1)) { return; }

  //   e.preventDefault();

  //   // window.location = $link.attr('href');
  //   // getProduct($link.attr('href'));
  // });

  $(window).on('resize', () => {
    if (!$('[data-state]').hasClass('State--shoppable-image-open')) { return; }
    positionModal();
    _.debounce(() => {
      initCarousels('[data-shoppable-image-modal]');
      standardizeHeights(grid_item_selector, child_selectors);
    }, 100, { maxWait: 100 })();
  });

  // $(document).on('click', '[data-shoppable-image-modal] [data-back]', (e) => {
  //   if (e.keyCode) {
  //     if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
  //   }

  //   $('[data-shoppable-image-modal] [data-bottom-view]').removeClass('ShoppableImage__bottom-view--phase-2');
  //   $('[data-add-to-cart-content]').empty();
  //   $(window).trigger('resize');
  // });

  let shoppable_is_closing = false;

  $(document).on('menusWillClose', () => {
    shoppable_is_closing = $('#ShoppableImage').hasClass('ShoppableImage__modal--open');
  });

  $(document).on('menusDidClose', () => {
    if (shoppable_is_closing) {
      setTimeout(() => {
        // Stupid check necessary because we need to check if the modal is closing "for real" and not just faking us out with the closeAllMenus on open.
        if ($('#ShoppableImage').hasClass('ShoppableImage__modal--open') && !$('#ShoppableImage').hasClass('ShoppableImage__modal--loading')) { return; }

        $('#ShoppableImage video').each((i, video) => {
          video.pause();
        });
      }, 10);
    }

    shoppable_is_closing = false;
  });

  $(document).on('click', '[data-close-modal]', () => {
    $('[data-shoppable-image-modal]').removeClass('ShoppableImage__modal--open');
    $('[data-shoppable-active="true"]').removeClass('ShoppableImage__trigger--active');
  });
};